import { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import Select from 'react-select'

import MobileHeader from '../Common/Header/MobileHeader'
import useCheckMobileScreen from '../../common/hooks/use-check-mobile-screen-hook'
import {
  PERMISSION_FEATURE,
  PERMISSION_SCREEN,
  PERMISSION_TYPE,
  PRODUCT_DETAIL_FIELDS,
} from '../../common/constant/page-constant'
import {
  HEADER_CONFIG,
  HEADER_CONST,
} from '../../common/constant/common-constant'
import SearchIcon from '../../assets/SearchIcon'
import CloseIcon from '../../assets/CloseIcon'
import {
  getAllProductHelper,
  getAllSuppliersHelper,
  getMedicalCategoryHelper,
  getSearchDataHelper,
  getSearchSuggestionsHelper,
  upsertProductHelper,
} from '../../helper/settings-helper'
import './ManageProduct.scss'
import Alert from '../../components/Alert/Alert'
import {
  addProductAlertAction,
  updateProductAlertAction,
} from '../../modules/actions/action'
import DotsIcon from '../../assets/DotsIcon'
import PopupCard from '../Common/PopupCard/PopupCard'
import ManageProductForm from './ManageProductForm'
import usePagination from '../../common/hooks/usePagination'
import Pagination from '../../components/Pagination/Pagination'
import Loader from '../../components/Loader/Loader'

const ManageProduct = (props) => {
  const isMobile = useCheckMobileScreen()
  const inputRef = useRef()
  const pagination = usePagination({
    initialPage: 1,
    initialLimit: 50,
  })

  const [headerOptions, setHeaderOptions] = useState({
    [HEADER_CONFIG.IS_BACK_VISIBLE]: true,
    [HEADER_CONFIG.TITLE]: HEADER_CONST.MANAGE_CUSTOMER,
    [HEADER_CONFIG.HANDLE_BACK_FUNC]: () => props?.onBackClick(),
  })
  const [loginData, setLoginData] = useState({})
  const [manageProductData, setManageProductData] = useState([])
  const [filteredManageProductData, setFilteredManageProductData] = useState([])
  const [newProductData, setNewProductData] = useState({})
  const [viewSearch, setViewSearch] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const [permissions, setPermissions] = useState({})
  const [open, setOpen] = useState(false)
  const [isFieldErrorVisible, setIsFieldErrorVisible] = useState(false)
  const [addProductAlert, setAddProductAlert] = useState(false)
  const [updateProductAlert, setUpdateProductAlert] = useState(false)
  const [isEditFlow, setIsEditFlow] = useState(false)
  const [activeCardId, setActiveCardId] = useState(false)
  const [serverError, setServerError] = useState(undefined)
  const [medicalCategoryList, setMedicalCategoryList] = useState(undefined)
  const [supplierList, setSupplierList] = useState(undefined)
  const [searchSuggestions, setSearchSuggestions] = useState([])
  const [prevSearchTermLength, setPrevSearchTermLength] = useState(0)
  const [searchResults, setSearchResults] = useState([])
  const [timer, setTimer] = useState()
  const [loading, setLoading] = useState(false)
  const [isSearching, setIsSearching] = useState(false)

  const [deleteProductId, setDeleteProductId] = useState(null)

  useEffect(() => {
    // getProductData()
    getMedicalCategoryData()
    getSupplierData()
  }, [])

  useEffect(() => {
    let addProductAlert = props.alert?.addProductAlert
    let updateProductAlert = props.alert?.updateProductAlert
    setAddProductAlert(addProductAlert)
    setUpdateProductAlert(updateProductAlert)
  }, [props.alert?.addProductAlert, props.alert?.updateProductAlert])

  // #region Set Login Data and Permissions
  useEffect(() => {
    setLoginData(props.loginData)

    if (props.loginData.permissions) {
      let permission = props.loginData.permissions.filter(
        (permission) => permission.screen === PERMISSION_SCREEN.SETTINGS
      )[0]

      if (permission) setPermissions(permission)
    }
  }, [props.loginData])
  // #endregion Set Login Data and Permissions

  useEffect(() => {
    getSearchSuggestions(searchTerm)
    return () => clearTimeout(timer)
  }, [searchTerm])

  useEffect(() => {
    if (!isSearching) {
      getProductData()
    }
  }, [pagination.page, pagination.limit, isSearching])

  // #region Get Product Data
  const getProductData = async () => {
    setManageProductData([])
    setFilteredManageProductData([])
    setLoading(true)

    try {
      const params = { ...pagination.getQueryParams() }

      let { data, count, current_page } = await getAllProductHelper(
        undefined,
        params
      )

      // Update pagination state with API response data
      if (count !== undefined && count !== null) {
        pagination.setTotalItems(count)
      }

      // This ensures the pagination hook matches the API response
      if (current_page && current_page !== pagination.page) {
        console.warn(
          'Page mismatch - API:',
          current_page,
          'Local:',
          pagination.page
        )
      }

      setLoading(false)
      setManageProductData(data)
      setFilteredManageProductData(data)
    } catch (err) {
      console.log('err: ', err)
      setLoading(false)
    }
  }
  // #endregion Get Product Data

  // #region Clear Search Data
  const clearSearchData = () => {
    setIsSearching(false)
    setSearchSuggestions([])
    setPrevSearchTermLength(0)
    clearTimeout(timer)
    setTimer(() => null)
    setSearchResults(undefined)
    setFilteredManageProductData(manageProductData)
    pagination.goToPage(1)
  }
  // #endregion Clear Search Data

  // #region Search Suggestion Handler
  const getSearchSuggestions = (async) => {
    try {
      if (!searchTerm || searchTerm?.length === 0) {
        clearSearchData()
        return
      }

      const fetchSearchResults = async () => {
        // setIsLoading(true)
        const results = await getSearchSuggestionsHelper(searchTerm)
        setSearchSuggestions(results)

        // setIsLoading(false)
      }

      // Check if search term length changes by more than 2 characters
      if (
        searchTerm?.length > 0 &&
        Math.abs(searchTerm.length - prevSearchTermLength) > 2
      ) {
        clearTimeout(timer)
        setTimer(null)
        setPrevSearchTermLength(() => searchTerm.length)
        fetchSearchResults()
      } else {
        if (!timer) {
          let tr = setTimeout(() => {
            if (searchTerm.length > 0) {
              setPrevSearchTermLength(searchTerm.length)
              fetchSearchResults()
            }
          }, 1000)
          setTimer(tr)
        } else {
          // Clear the existing timer and set a new one
          clearTimeout(timer)
          let tr = setTimeout(() => {
            if (searchTerm.length > 0) {
              setPrevSearchTermLength(searchTerm.length)
              fetchSearchResults()
            }
          }, 1000)
          setTimer(tr)
        }
      }
    } catch (err) {
      console.log('err in search suggestion: ', err)
    }
  }
  // #endregion Search Suggestion Handler

  // #region Search Handler
  const handleSearch = async (option) => {
    try {
      setIsSearching(true)

      const data = await getSearchDataHelper(option)

      pagination.setTotalItems(data.length)
      pagination.goToPage(1)

      setSearchResults(data)
      setFilteredManageProductData(data)
    } catch (err) {}
  }

  const expandSearch = () => {
    inputRef.current.focus(setViewSearch(true))
  }
  // #endregion Search Handler

  // #region Card Action Handler
  const handleCardAction = async (product, action) => {
    if (action === 'EDIT') {
      handleEditProductData({ ...product })
      handleDrawerToggle()
      setIsEditFlow(true)
      setActiveCardId(undefined)
    } else if (action === 'DELETE') {
      try {
        setDeleteProductId(product?.id)
      } catch (err) {
        console.log('err: ', err)
        setActiveCardId(undefined)
      }
    }
  }
  // #endregion Card Action Handler

  // #region Delete Product Handler
  const handleDeleteProduct = async (product) => {
    let data = {
      id: product?.id,
      action: 'DELETE',
    }

    let dataStringify = JSON.stringify(data)

    let formData = new FormData()
    formData.append('data', dataStringify)

    await upsertProductHelper(formData)
    getProductData()
    setActiveCardId(undefined)
  }
  // #endregion Delete Product Handler

  // #region Edit Product Data Handler
  const handleEditProductData = (product) => {
    let data = {
      id: product.id,
      [PRODUCT_DETAIL_FIELDS.PRODUCT_NAME]: product?.name,
      [PRODUCT_DETAIL_FIELDS.DOSE]: product?.dose,
      [PRODUCT_DETAIL_FIELDS.GENERIC_NAME]: product?.generic_name,
      [PRODUCT_DETAIL_FIELDS.MEDICAL_CATEGORY]: medicalCategoryList?.find(
        (category) => category?.value === product?.category
      ).value,
      [PRODUCT_DETAIL_FIELDS.SUPPLIER]: supplierList?.find(
        (supplier) => supplier?.name === product?.supplier_name
      ),
      [PRODUCT_DETAIL_FIELDS.ORIGIN]: product?.origin,
      [PRODUCT_DETAIL_FIELDS.PRODUCT_CATEGORY]: product?.type,
      [PRODUCT_DETAIL_FIELDS.PRESCRIPTION_REQUIRED]:
        product.is_prescription_required ? 'YES' : 'NO',
      [PRODUCT_DETAIL_FIELDS.PRODUCT_IMAGE]: product?.product_image,
      [PRODUCT_DETAIL_FIELDS.RATE_PER_UNIT]: product?.rate_per_unit,
    }

    setNewProductData(data)
  }
  // #endregion Edit Product Data Handler

  // #region Get Medical Category Data
  const getMedicalCategoryData = () => {
    getMedicalCategoryHelper()
      .then((res) => {
        setMedicalCategoryList([...res])
      })
      .catch((err) => {
        console.log(err)
      })
  }
  // #endregion Get Medical Category Data

  // #region Get Supplier Data
  const getSupplierData = () => {
    getAllSuppliersHelper()
      .then((res) => {
        setSupplierList([...res])
      })
      .catch((err) => {
        console.log(err)
      })
  }
  // #endregion Get Supplier Data

  // #region Validation Handler
  const checkValidation = () => {
    if (
      newProductData[PRODUCT_DETAIL_FIELDS.PRODUCT_NAME] &&
      newProductData[PRODUCT_DETAIL_FIELDS.DOSE] &&
      newProductData[PRODUCT_DETAIL_FIELDS.GENERIC_NAME] &&
      newProductData[PRODUCT_DETAIL_FIELDS.MEDICAL_CATEGORY] &&
      newProductData[PRODUCT_DETAIL_FIELDS.SUPPLIER] &&
      newProductData[PRODUCT_DETAIL_FIELDS.ORIGIN] &&
      newProductData[PRODUCT_DETAIL_FIELDS.PRODUCT_CATEGORY] &&
      newProductData[PRODUCT_DETAIL_FIELDS.PRESCRIPTION_REQUIRED]
    ) {
      return true
    }

    return false
  }
  // #endregion Validation Handler

  // #region Submit Handler
  const handleSubmit = async () => {
    setServerError(undefined)
    if (!checkValidation()) {
      setIsFieldErrorVisible(true)
      return
    }

    setIsFieldErrorVisible(false)
    let { product_image, ...pDetails } = newProductData

    let data = {
      supplier_id: newProductData?.supplier?.id,
      product_details: pDetails,
    }

    let dataStringify = JSON.stringify(data)

    let formData = new FormData()
    formData.append('data', dataStringify)
    if (product_image) formData.append('product_image', product_image)

    try {
      await upsertProductHelper(formData)

      if (isEditFlow) {
        setIsEditFlow(false)
        props.updateProductAlertAction(true)

        setTimeout(() => {
          props.updateProductAlertAction(false)
        }, 5000)
      } else {
        props.addProductAlertAction(true)

        setTimeout(() => {
          props.addProductAlertAction(false)
        }, 5000)
      }

      getProductData()
      resetDrawerData()
      handleDrawerToggle()
    } catch (err) {
      setServerError(err)
    }
  }
  // #endregion Submit Handler

  // #region Product Details Update Handler
  const handleProductDetailsUpdate = (key, value) => {
    setServerError(undefined)
    setNewProductData((newProductData) => {
      let npData = { ...newProductData }

      npData[key] = value

      return npData
    })
  }
  // #endregion Product Details Update Handler

  // #region Drawer Toggle Handler
  const handleDrawerToggle = () => {
    if (open) {
      resetDrawerData()
    } else {
    }
    setOpen(!open)
  }

  const resetDrawerData = () => {
    setNewProductData({})
    setIsEditFlow(false)
  }
  // #endregion Drawer Toggle Handler

  return (
    <>
      {isMobile && <MobileHeader headerOptions={headerOptions} />}
      {addProductAlert && (
        <Alert
          success
          alertType="success"
          alertMessage="New Product added Successfully!"
          onClose={() => props.addProductAlertAction(false)}
        />
      )}
      {updateProductAlert && (
        <Alert
          success
          alertType="success"
          alertMessage="Product updated Successfully!"
          onClose={() => props.updateProductAlertAction(false)}
        />
      )}
      <div className="pageBodyRightPanel">
        {isMobile && (
          <div className="addProductBtnMobile dFlex aiCenter mwebVisible fixed">
            <div
              className={'formGroup mb-0 searchBar expand'}
              onClick={expandSearch}
              onBlur={() => setViewSearch(false)}
            >
              <input
                ref={inputRef}
                type="text"
                className="formControl"
                placeholder="Search Supplier Name/Number"
                onChange={(e) => setSearchTerm(e?.target?.value)}
              />
              <div className={`searchIcon`}>
                <SearchIcon />
              </div>
            </div>
          </div>
        )}
        {!isMobile && (
          <div className="pageBodyRightPanelHeader dFlex jcSpaceBetween aiCenter mb-5">
            <div className="pageBodyRightPanelHeading">Manage Product</div>
            <div className="addProductBtn dFlex aiCenter productSearchBtn">
              <div className="formGroup formFloating fgrow1 maxWidth">
                <Select
                  className="formSelect reactSelect"
                  id="floatingSelect"
                  options={searchSuggestions}
                  onInputChange={(option) => {
                    if (option) setSearchTerm(option)
                  }}
                  onChange={(option) => {
                    if (!option) {
                      clearSearchData()
                    } else {
                      handleSearch(option)
                    }
                    // setSelectedSearchTerm(option?.value)
                  }}
                  placeholder="Search Product/Supplier"
                  styles={{
                    control: (base) => ({
                      border: 0,
                      display: 'flex',
                      paddingTop: '20px',
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused
                        ? 'rgb(222, 235, 255)'
                        : state.isSelected
                          ? '#FFF'
                          : 'inherit',
                      color: '#212529',
                      '&:hover': {
                        backgroundColor: state.isSelected
                          ? '#DEEBFF'
                          : 'rgb(222, 235, 255)',
                      },
                    }),
                  }}
                  getOptionLabel={(option) => `${option.name} (${option.type})`}
                  isClearable
                />
                <label htmlFor="floatingSelect">Search Product/Supplier</label>
                {isFieldErrorVisible &&
                  !newProductData?.[PRODUCT_DETAIL_FIELDS.MEDICAL_CATEGORY] && (
                    <div class="invalidFeedback">
                      Please choose Medical Category.
                    </div>
                  )}
              </div>
              {permissions?.features?.[PERMISSION_FEATURE.MANAGE_PRODUCT] ===
                PERMISSION_TYPE.MANAGE && (
                <button
                  className="btn btnPrimary ml-4"
                  onClick={handleDrawerToggle}
                >
                  ADD
                </button>
              )}
            </div>
          </div>
        )}
        {/* <div className="productLlistWrap dFlex"> */}
        <div className="productLlistWrap">
          {filteredManageProductData && (
            <div className="tabContent mb-4">
              <div className="">
                <table className="table productTable">
                  <thead>
                    <tr>
                      <th width="1%"></th>

                      <th width="29%">Product Details (Name-Size-Generic)</th>
                      <th width="8%">Category</th>
                      <th width="24%">Supplier/Manufacturer</th>
                      <th width="7%">Origin</th>
                      {/* <th width="10%">Cr/Type</th> */}
                      <th width="10%">Type</th>
                      <th title={'RPU (BDT)'} width="8%">
                        RPU (BDT)
                      </th>

                      <th title={'Prescription Mode'} width="11%">
                        Prescription Mode
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredManageProductData?.map((item, index) => (
                      <tr key={item?.id}>
                        <td>
                          {permissions?.features?.[
                            PERMISSION_FEATURE.MANAGE_PRODUCT
                          ] === PERMISSION_TYPE.MANAGE && (
                            <div className="cardHeaderRight">
                              {activeCardId === item?.id ? (
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    setActiveCardId(undefined)
                                  }}
                                >
                                  <CloseIcon />
                                </span>
                              ) : (
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    setActiveCardId(item?.id)
                                  }}
                                >
                                  <DotsIcon />
                                </span>
                              )}
                              {activeCardId === item?.id && (
                                <>
                                  <ul
                                    className={`cardActionsWrapper ${
                                      activeCardId === item?.id
                                        ? 'show'
                                        : 'hide'
                                    }`}
                                  >
                                    <li
                                      className="actionItem"
                                      onClick={(e) => {
                                        e.stopPropagation()
                                        handleCardAction(item, 'EDIT')
                                      }}
                                    >
                                      Edit
                                    </li>
                                    <li
                                      className="actionItem"
                                      onClick={(e) => {
                                        e.stopPropagation()
                                        handleCardAction(item, 'DELETE')
                                      }}
                                    >
                                      Delete
                                    </li>
                                  </ul>
                                  {deleteProductId === item?.id && (
                                    <PopupCard
                                      header="Delete selected Product?"
                                      body={`${item?.product_details}`}
                                    >
                                      <button
                                        className="btn btnPrimaryOutlined dFlex"
                                        onClick={() => setDeleteProductId(null)}
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        className="btn btnPrimary dFlex"
                                        onClick={() =>
                                          handleDeleteProduct(item)
                                        }
                                      >
                                        Delete
                                      </button>
                                    </PopupCard>
                                  )}
                                </>
                              )}
                            </div>
                          )}
                        </td>
                        <td title={item.product_details}>
                          {item.product_details}
                        </td>
                        <td title={item.category}>{item.category}</td>
                        <td title={item.supplier_name}>{item.supplier_name}</td>
                        <td>{item.origin}</td>
                        <td>{item.type}</td>
                        <td>{item.rate_per_unit}</td>
                        <td>
                          {item.is_prescription_required
                            ? 'Required'
                            : 'Not Required'}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          {loading ? (
            <Loader />
          ) : (
            <Pagination
              currentPage={pagination.page}
              totalPages={pagination.totalPages}
              onPageChange={pagination.goToPage}
              onPrevPage={pagination.prevPage}
              onNextPage={pagination.nextPage}
              onFirstPage={pagination.firstPage}
              onLastPage={pagination.lastPage}
              hasNextPage={pagination.hasNextPage}
              hasPrevPage={pagination.hasPrevPage}
              showFirstLast={true}
              maxPageButtons={5}
            />
          )}
        </div>
        {/* </div> */}
        <ManageProductForm
          handleDrawerToggle={handleDrawerToggle}
          open={open}
          serverError={serverError}
          newProductData={newProductData}
          handleProductDetailsUpdate={handleProductDetailsUpdate}
          isFieldErrorVisible={isFieldErrorVisible}
          medicalCategoryList={medicalCategoryList}
          handleSubmit={handleSubmit}
          supplierList={supplierList}
          props={props}
        />
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    alert: state.alertReducer.alert,
    loginData: state.loginDataReducer?.loginData,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addProductAlertAction: (payload) =>
      dispatch(addProductAlertAction(payload)),
    updateProductAlertAction: (payload) =>
      dispatch(updateProductAlertAction(payload)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageProduct)
